import React from "react";
import { Link } from "react-router-dom";
import "./ProductItem.css";

const ProductItem = ({ product, selectedItem, route }) => {
  return (
    <div className="wpo-team-item product-item">
      <Link to={`${route}/${selectedItem.id}/details/${product.id}`}>
        <div className="wpo-team-img">
          <img src={product.image} alt="" />
          <Link
            to={`${route}/${selectedItem.id}/details/${product.id}`}
            className="product-item-hover"
          >
            {product.ficheTechnique &&
              product.ficheTechnique.map((pr) => (
                <p key={pr.key}>
                  <span>{pr.key}</span>
                  {pr.value.length < 30 && pr.value}
                </p>
              ))}
          </Link>
        </div>
      </Link>
      <div className="wpo-team-text">
        <h3>
          <Link to={`${route}/${selectedItem.id}/details/${product.id}`}>
            {product.name}
          </Link>
        </h3>
      </div>
    </div>
  );
};

export default ProductItem;
